import React, { useContext } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";

function AdminLanding() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  return (
    <div className="admin-landing-wrapper">
      {/* Admin Hero Section */}
      <div className="admin-hero-section">
        <Container>
          <div className="text-center py-5">
            <div className="hero-icon-container mx-auto mb-4">
              <i className="fas fa-crown text-white"></i>
            </div>
            <h1 className="display-4 fw-bold text-white mb-3">
              Welcome Back, {user?.firstName || "Admin"}!
            </h1>
            <p className="lead text-white-50 mb-4">
              Manage your e-commerce platform with powerful administrative tools
            </p>
            <div className="admin-badge">
              <i className="fas fa-shield-alt me-2"></i>
              Admin Panel
            </div>
          </div>
        </Container>
      </div>

      {/* Quick Stats Section */}
      <Container className="admin-content">
        {/* Quick Access Section */}
        <Row className="mt-5">
          <Col>
            <h2 className="text-center mb-4 fw-bold text-dark">
              <i className="fas fa-bolt me-3 text-warning"></i>
              Quick Access
            </h2>
          </Col>
        </Row>

        <Row className="g-4 mb-5">
          <Col md={4} sm={6}>
            <Card className="admin-quick-card border-0 shadow-lg h-100 text-center">
              <Card.Body className="p-4">
                <div className="admin-quick-icon mb-3">
                  <i className="fas fa-plus-circle"></i>
                </div>
                <h4 className="fw-bold mb-3">Create Product</h4>
                <p className="text-muted mb-4">
                  Add new products to your inventory with detailed
                  specifications
                </p>
                <Button
                  onClick={() => navigate("/add-product")}
                  className="admin-quick-btn w-100"
                  size="lg"
                >
                  <i className="fas fa-plus me-2"></i>
                  Create New Product
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} sm={6}>
            <Card className="admin-quick-card border-0 shadow-lg h-100 text-center">
              <Card.Body className="p-4">
                <div className="admin-quick-icon mb-3">
                  <i className="fas fa-clipboard-list"></i>
                </div>
                <h4 className="fw-bold mb-3">Manage Orders</h4>
                <p className="text-muted mb-4">
                  View, process, and track customer orders and delivery status
                </p>
                <Button
                  onClick={() => navigate("/orders")}
                  className="admin-quick-btn w-100"
                  size="lg"
                >
                  <i className="fas fa-list me-2"></i>
                  View Orders
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} sm={6}>
            <Card className="admin-quick-card border-0 shadow-lg h-100 text-center">
              <Card.Body className="p-4">
                <div className="admin-quick-icon mb-3">
                  <i className="fas fa-cogs"></i>
                </div>
                <h4 className="fw-bold mb-3">Product Management</h4>
                <p className="text-muted mb-4">
                  Edit, archive, or update existing products in your catalog
                </p>
                <Button
                  onClick={() => navigate("/products")}
                  className="admin-quick-btn w-100"
                  size="lg"
                >
                  <i className="fas fa-edit me-2"></i>
                  Manage Products
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Administrative Tools Section */}
        <Row className="mb-5">
          <Col>
            <h2 className="text-center mb-4 fw-bold text-dark">
              <i className="fas fa-tools me-3 text-primary"></i>
              Administrative Tools
            </h2>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={6}>
            <Card className="admin-feature-card border-0 shadow-lg h-100">
              <Card.Body className="p-5 text-center">
                <div className="feature-icon mb-4">
                  <i className="fas fa-user-shield"></i>
                </div>
                <h4 className="fw-bold mb-3">User Management</h4>
                <p className="text-muted mb-4">
                  Monitor user activity, manage permissions, and oversee
                  customer accounts
                </p>
                <Button
                  onClick={() => navigate("/users")}
                  variant="outline-primary"
                  size="lg"
                  className="admin-feature-btn"
                >
                  <i className="fas fa-users-cog me-2"></i>
                  Manage Users
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AdminLanding;
